





















































import Vue from 'vue';
import PlaylistModal from '@/web/components/playlists/PlaylistModal';
import AddToPlaylistModal from '@/web/components/playlists/AddToPlaylistModal';

export default Vue.extend({
  name: 'PlaylistsPanel',
  props: {
    playlists: {
      type: Array as () => PlaylistResponse[],
    },
    mediaItemsSelected: {
      type: Array,
    },
    mediaItemsSelectedEntity: {
      type: Array,
    },
  },
  data() {
    return {
      playlist: {
        id: null,
        name: null,
        image: null,
        items: [],
        media: {
          file_content: 'playlist',
        },
      },
    };
  },
  methods: {
    addToPlaylist() {
      this.$modal.show(AddToPlaylistModal, {
        playlists: this.playlists,
        mediaItemsSelected: this.mediaItemsSelectedEntity,
        confirm: playlist => this.onMediaAddToPlaylist(playlist),
      });
    },
    createPlaylist() {
      this.$modal.show(PlaylistModal, {
        playlists: this.playlists,
        mediaItemsSelected: this.mediaItemsSelected,
        confirm: playlist => this.onPlaylistCreated(playlist),
      });
    },
    onPlaylistCreated(playlist) {
      this.$emit('createPlaylist', playlist);
      this.$emit('deselectItems');
    },
    onMediaAddToPlaylist(playlist) {
      this.mediaItemsSelectedEntity.forEach(item => {
        playlist.content.push(item);
      });
      this.$emit('addMediaToPlaylist', playlist);
      this.$emit('deselectItems');
    },
  },
});
